/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { FormattedMessage } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { errorIcon } from '../assets';

import messages from './messages';

const styles = cssMap({
	image: {
		width: '272px',
	},
	root: {
		height: '100%',
		paddingBottom: token('space.800'),
	},
	content: {
		textAlign: 'center',
		maxWidth: '424px',
	},
});

export const GenericErrorPage = () => {
	return (
		<Stack alignInline="center" space="space.200" alignBlock="center" xcss={styles.root}>
			<img src={errorIcon} alt="error page" css={styles.image} />
			<div css={styles.content}>
				<Stack space="space.200">
					<Heading size="xlarge">
						<FormattedMessage {...messages.genericErrorHeading} />
					</Heading>
					<Text>
						<FormattedMessage {...messages.genericErrorDescription} />
					</Text>
				</Stack>
			</div>
		</Stack>
	);
};
